// extracted by mini-css-extract-plugin
export default {"modal":"NP-z","error":"OP-z","disabled":"PP-z","fields":"QP-z","errorMsg":"RP-z","footer":"SP-z","formContentWrapper":"TP-z","productImage":"UP-z","overlay":"VP-z"};